/**
 * Copyright Highway9 Networks Inc.
 */
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import { ApiTokenService } from "~/services";
import { ApiToken } from "~/types/ApiToken";

// Define the state type for the slice
interface ApiTokenState {
  loading: boolean;
  data: ApiToken[];
  current: ApiToken | null;
  open: boolean;
}

// Initial state
const initialState: ApiTokenState = {
  loading: true,
  data: [],
  current: null,
  open: false,
};

// Async thunks for API calls
export const fetchApiTokens = createAsyncThunk(
  "apiToken/fetchApiTokens",
  async () => {
    try {
      const data = await ApiTokenService.getApiTokensData();
      return data;
    } catch (error) {
      console.error("Error fetching access config data:", error);
      throw error;
    }
  }
);


// Create the slice
const apiTokenSlice = createSlice({
  name: "apiToken",
  initialState,
  reducers: {
    setSelected: (state, action: PayloadAction<ApiToken | null>) => {
      state.current = action.payload;
    },
    setDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApiTokens.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
  },
});

// Export actions
export const apiTokenActions = apiTokenSlice.actions;

// Export selectors
export const apiTokenData = (state: RootState) => state.apiToken.data;
export const apiTokenState = (state: RootState) => state.apiToken.current;
export const apiTokenLoading = (state: RootState) => state.apiToken.loading;
export const apiTokenOpen = (state: RootState) => state.apiToken.open;


// Export reducer
export default apiTokenSlice.reducer;
